import { Schema } from 'effect';
import { Ecosystem } from '@finnest/core/effect';
import { SliceEnvironment } from '@finnest/runtime-cd-contract/platform-fields';
import { CustomerId, TenantId } from '../../onboarding/vocabulary/ids/branded-ids.ts';

export const sourceModeSchema = Schema.Literals(['live', 'artifact', 'demo']);
export type SourceMode = typeof sourceModeSchema.Type;

// Canonical regulatory ecosystem lives in `@finnest/core`. Keep the local
// export name as a plain alias so existing consumers keep compiling without
// redeclaring the `ofb`/`opin` vocabulary (single-source-of-truth).
export const regulatoryEcosystemSchema = Ecosystem;
export type RegulatoryEcosystem = Ecosystem;

export const adminDataScopeSchema = Schema.Struct({
  sourceMode: sourceModeSchema,
  // The environment and the ecosystem are the deployment profile's: the admin reads them from the
  // deployment it runs against, never presumes them.
  environment: SliceEnvironment,
  tenantId: TenantId,
  customerId: Schema.optionalKey(CustomerId),
  ecosystem: regulatoryEcosystemSchema,
}).annotate({
  title: 'Power Admin data scope',
  description:
    'Runtime scope used by Power Admin to separate source mode, environment, tenant, customer, and ecosystem.',
});
export type AdminDataScope = typeof adminDataScopeSchema.Type;

export const sourceStatusSchema = Schema.Struct({
  scope: adminDataScopeSchema,
  label: Schema.NonEmptyString,
  evidenceLevel: Schema.Literals(['live-operational', 'generated-artifact', 'demo-seed']),
  mutationsEnabled: Schema.Boolean,
}).annotate({
  title: 'Power Admin source status',
  description: 'Visible source-mode status shown in the Power Admin shell.',
});
export type SourceStatus = typeof sourceStatusSchema.Type;

export const sourceModeOptions = sourceModeSchema.literals;
